const UPDATE_NEW_PROJECT_SPECIAL_NOTE_CONTENTS =
  "UPDATE_NEW_PROJECT_SPECIAL_NOTE_CONTENTS";
const ADD_NEW_PROJECT_SPECIAL_NOTE_RESET_DATA =
  "ADD_NEW_PROJECT_SPECIAL_NOTE_RESET_DATA";

export default {
  UPDATE_NEW_PROJECT_SPECIAL_NOTE_CONTENTS,
  ADD_NEW_PROJECT_SPECIAL_NOTE_RESET_DATA,
};
